import type { ReactNode } from "react";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";

interface ReportsSectionProps {
  /** Section title displayed above the items */
  title: string;
  /** List items to render inside the section */
  children: ReactNode;
}

export function ReportsSection({ title, children }: ReportsSectionProps) {
  const { theme } = useUnistyles();

  return (
    <View
      bg="surfaceCardInner"
      borderWidth={1}
      borderColor="borderCard"
      borderRadius={theme.spacing.xl}
      p="5xl"
      gap="3xl"
    >
      <Text textStyle="md/semibold" color="textMuted">
        {title}
      </Text>
      <View gap="md">{children}</View>
    </View>
  );
}
